import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useUpdateSegment = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('segments/update/'), body, additional),
        onSuccess: (response, request) => {
            queryClient.setQueryData(segmentKeys.detail(request.segment_id), (current) => current
                ? {
                    ...current,
                    data: {
                        ...current.data,
                        ...(request.name !== undefined && { name: request.name }),
                        ...(request.match !== undefined && { match: request.match }),
                        ...(request.filters !== undefined && {
                            filters: request.filters
                        }),
                        ...(request.source_segment_id !== undefined && {
                            source_segment_id: request.source_segment_id,
                            source_segment_name: request.source_segment_id ===
                                current.data.source_segment_id
                                ? current.data.source_segment_name
                                : null
                        }),
                        match_count: response.data.match_count
                    }
                }
                : current);
            return queryClient.invalidateQueries({ queryKey: segmentKeys.all });
        }
    });
};
export default useUpdateSegment;
